import { render } from "./cpt-image-option.vue?vue&type=template&id=b880f216"
import script from "./cpt-image-option.vue?vue&type=script&lang=js"
export * from "./cpt-image-option.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__